import { render } from "./Emoticon.vue?vue&type=template&id=95d3713a&scoped=true"
import script from "./Emoticon.vue?vue&type=script&lang=js"
export * from "./Emoticon.vue?vue&type=script&lang=js"

import "./Emoticon.vue?vue&type=style&index=0&id=95d3713a&lang=scss&scoped=true"

import exportComponent from "/home/webiotcpc/dhruvi/Git/tivo/vue-tivo/tivo-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95d3713a"]])

export default __exports__